module.exports = __webpack_public_path__ + "img/calendarBlack.4901bdc0.gif";